import { useEffect, useRef, useState } from "react";
import api from "../api/api";

const DEBOUNCE_MS = 250;

/**
 * Серверний розрахунок кошика: ціни, акція, доставка, підсумок.
 * Ті самі правила, що й при оформленні — тож покупець бачить фінальну суму.
 * Поки запит у дорозі, повертає попередній результат (або null).
 */
const useCartQuote = (items, deliveryMethod, promoCode) => {
  const [quote, setQuote] = useState(null);
  const [loading, setLoading] = useState(false);
  const requestId = useRef(0);

  // Стабільний ключ, щоб не перезапитувати при кожному ре-рендері
  const itemsKey = items.map((i) => `${i.id}:${i.quantity}`).join(",");

  useEffect(() => {
    if (!itemsKey) {
      setQuote(null);
      return undefined;
    }

    const id = ++requestId.current;
    setLoading(true);

    const timer = setTimeout(async () => {
      try {
        const { data } = await api.post("/orders/quote/", {
          items: itemsKey.split(",").map((pair) => {
            const [productId, quantity] = pair.split(":");
            return { id: Number(productId), quantity: Number(quantity) };
          }),
          delivery_method: deliveryMethod ? Number(deliveryMethod) : null,
          promo_code: promoCode || "",
        });
        // Відповідь на застарілий запит ігноруємо
        if (id === requestId.current) setQuote(data);
      } catch (err) {
        console.error("Cart quote failed", err);
      } finally {
        if (id === requestId.current) setLoading(false);
      }
    }, DEBOUNCE_MS);

    return () => clearTimeout(timer);
  }, [itemsKey, deliveryMethod, promoCode]);

  return { quote, loading };
};

export default useCartQuote;
